<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title>{{ hsct.eign_naam }}</v-card-title>
            <v-divider></v-divider>
            <!-- <p class=".title ma-2"> {{hsct.eign_naam }} </p> -->
            <div class="ma-2">
                <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                        <v-select v-model="hsct.hsct_eigenaar" :items="hsct_eigenaarKeuzes" item-value="code" item-text="desc" label="Legal owner"></v-select>
                    </v-col>
                    <v-col cols="1" class="px-1"/>
                    <v-col cols="3" class="px-1">
                        <v-select v-model="hsct.hsct_eign_boek_mag" :items="hsct_eigenBoekingKeuzes" item-value="code" item-text="desc" label="Owner bookings"></v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                        <v-select v-model="hsct.hsct_sleutel" :items="hsct_sleutelKeuzes" item-value="code" item-text="desc" label="Key pickup"></v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_iban"
                            label="Bank account IBAN (Only if different from Host IBAN)"
                            dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_iban_naam"
                            label="Host name for bank account (Only if different from Host name)"
                            dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-1 pb-2">
                        <v-checkbox v-model="hsct.hsct_bank_stop" :disabled="!hsct.hsct_payment_stop" label="Payment stop" dense></v-checkbox>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_perc_kosten_aandeel"
                            type="number"
                            label="Agent commission percentage costs part"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_schaal_jaar1"
                            type="number"
                            label="Agent commission scale year 1"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_schaal_jaar2"
                            type="number"
                            label="Agent commission scale year 2"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_schaal_jaar3"
                            type="number"
                            label="Agent commission scale year 3"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_schaal_jaar4"
                            type="number"
                            label="Agent commission scale year 4"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.hsct_view_comm">
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="hsct.hsct_agtn_schaal_jaar5"
                            type="number"
                            label="Agent commission scale year 5"
                            :disabled="!hsct.hsct_update_comm" dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="hsct.ctrl_nr === 50">
                    <v-col cols="12" class="px-1">
                        <v-textarea v-model="hsct.hsct_ctrl_detail" label="Role details" rows=3></v-textarea>
                    </v-col>
                </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="saveHsct2">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                hsct_encrid: null,
                hsct: {},
                hsct_eigenaarKeuzes: [],
                hsct_sleutelKeuzes: [],
                hsct_eigenBoekingKeuzes: [],
          }
        },
        mounted(){
            console.log ("mounted");
        },
        methods: {
            open(hsct_encrid) {
                this.$emit("showSnackbar");
                this.dialog = true;
                var deze = this;
                this.$axios.post("ares/json/ares/huis/hsct/getHsct2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsct2"
                    },
                    getHsct2: {
                        hsct_encrid: hsct_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsct = res.data.getHsct2;
                        deze.hsct_eigenaarKeuzes = res.data.getHsct2.hsct_eigenaarKeuzes
                        deze.hsct_sleutelKeuzes = res.data.getHsct2.hsct_sleutelKeuzes
                        deze.hsct_eigenBoekingKeuzes = res.data.getHsct2.hsct_eigenBoekingKeuzes
                    }
                });
            },
            saveHsct2() {
                this.$axios.post("ares/json/ares/huis/hsct/saveHsct2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHsct2"
                    },
                    saveHsct2: {
                        hsct_encrid: this.hsct.hsct_encrid,
                        hsct_eigenaar: this.hsct.hsct_eigenaar,
                        hsct_iban: this.hsct.hsct_iban,
                        hsct_iban_naam: this.hsct.hsct_iban_naam,
                        hsct_sleutel: this.hsct.hsct_sleutel,
                        hsct_eign_boek_mag: this.hsct.hsct_eign_boek_mag,
                        hsct_bank_stop: this.hsct.hsct_bank_stop,
                        hsct_agtn_schaal_jaar1: this.hsct.hsct_agtn_schaal_jaar1,
                        hsct_agtn_schaal_jaar2: this.hsct.hsct_agtn_schaal_jaar2,
                        hsct_agtn_schaal_jaar3: this.hsct.hsct_agtn_schaal_jaar3,
                        hsct_agtn_schaal_jaar4: this.hsct.hsct_agtn_schaal_jaar4,
                        hsct_agtn_schaal_jaar5: this.hsct.hsct_agtn_schaal_jaar5,
                        hsct_agtn_perc_kosten_aandeel: this.hsct.hsct_agtn_perc_kosten_aandeel,
                        hsct_ctrl_detail: this.hsct.hsct_ctrl_detail,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHsct2.text,
                            color: res.data.saveHsct2.color
                        });
                        this.$emit('updateData');
                        this.dialog = false;
                    }
                });
            },
        }
    }
</script>

